import { BodyDefaultTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  ${BodyDefaultTypography};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.BLACK_900};
`
